// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"61f22658","186":"6e4fc4c4","344":"b8fdc7de","372":"227c7482","377":"4254ee2b","630":"c3654107","738":"b2bfa0d2","841":"9ad0a22a","856":"df2d6fd2"}[chunkId] + ".chunk.js";
};